export default {
  props: {
    count: Number,
    pageSize: Number,
    type: String,
    page: Number,
  },
  data: function () {
    return {
      currency: null,
      currentPage: 1,
    }
  },
  watch: {
    'page'() {
      if (this.page === 0) {
        this.currentPage = 1
      }
    },
  },
  created() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
  },
  methods: {
    changePagination(page) {
      this.currentPage = page
      this.$emit('onPagination', page - 1)
    },
  },
}
